import script from "./Nav.vue?vue&type=script&lang=ts&setup=true"
export * from "./Nav.vue?vue&type=script&lang=ts&setup=true"

import "./Nav.vue?vue&type=style&index=0&id=b2c9ffa6&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\viglacera\\nhathau\\fe\\source005\\vig_contructor_fe_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2c9ffa6"]])

export default __exports__